import { Card } from './ui/card';
import { Skeleton } from './ui/skeleton';

export const FoodSectionSkleton = () => (
  <div className="flex flex-col space-y-2">
    <Skeleton className="w-1/3 h-[22px] rounded-2xl bg-white" />
    <div className="grid grid-cols-2 gap-2">
      <Card className="flex flex-col bg-fill-base shadow-none border-none p-2 rounded-[20px] gap-y-1 min-w-[167px]">
        <Skeleton className="w-full h-[140px] rounded-2xl " />
        <div className="flex flex-col gap-y-1 px-[2px] pb-[8px]">
          <Skeleton className="w-1/3 h-[12px] rounded-2xl" />
          <Skeleton className="w-1/2 h-[14px] rounded-2xl" />
        </div>

        <Skeleton className="w-full h-8 rounded-full" />
      </Card>
      <Card className="flex flex-col bg-fill-base shadow-none border-none p-2 rounded-[20px] gap-y-1 min-w-[167px]">
        <Skeleton className="w-full h-[140px] rounded-2xl " />
        <div className="flex flex-col gap-y-1 px-[2px] pb-[8px]">
          <Skeleton className="w-1/3 h-[12px] rounded-2xl" />
          <Skeleton className="w-1/2 h-[14px] rounded-2xl" />
        </div>

        <Skeleton className="w-full h-8 rounded-full" />
      </Card>
      <Card className="flex flex-col bg-fill-base shadow-none border-none p-2 rounded-[20px] gap-y-1 min-w-[167px]">
        <Skeleton className="w-full h-[140px] rounded-2xl " />
        <div className="flex flex-col gap-y-1 px-[2px] pb-[8px]">
          <Skeleton className="w-1/3 h-[12px] rounded-2xl" />
          <Skeleton className="w-1/2 h-[14px] rounded-2xl" />
        </div>

        <Skeleton className="w-full h-8 rounded-full" />
      </Card>
    </div>
  </div>
);
